import { ref } from 'vue';

export const useLoadWithRetry = (config = {}) => {
  const maxRetry = config.max_retry || 3;
  const backoff = config.backoff || 1000;
  const mediaType = config.type || 'image';

  const isLoaded = ref(false);
  const hasError = ref(false);

  const loadWithRetry = async url => {
    const attemptLoad = () => {
      return new Promise((resolve, reject) => {
        let media;
        if (mediaType === 'audio') {
          media = new Audio();
        } else if (mediaType === 'video') {
          media = document.createElement('video');
        } else {
          media = new Image();
        }
        const loadedEvent = mediaType === 'image' ? 'load' : 'loadedmetadata';

        const handleLoaded = () => {
          isLoaded.value = true;
          hasError.value = false;
          resolve();
        };

        const handleError = () => {
          reject(new Error(`Failed to load ${mediaType}`));
        };

        media.addEventListener(loadedEvent, handleLoaded, { once: true });
        media.addEventListener('error', handleError, { once: true });
        if (mediaType !== 'image') media.preload = 'metadata';
        media.src = url;
        if (mediaType !== 'image') media.load();
      });
    };

    const sleep = ms => {
      return new Promise(resolve => {
        setTimeout(resolve, ms);
      });
    };

    const retry = async (attempt = 0) => {
      try {
        await attemptLoad();
      } catch (error) {
        if (attempt + 1 >= maxRetry) {
          hasError.value = true;
          isLoaded.value = false;
          return;
        }
        await sleep(backoff * (attempt + 1));
        await retry(attempt + 1);
      }
    };

    await retry();
  };

  return {
    isLoaded,
    hasError,
    loadWithRetry,
  };
};
